import { createBooleanQueryParamState } from './manager';

export const pwaLaunchGlobalState = createBooleanQueryParamState('pwa', false);
